module.exports = __webpack_public_path__ + "static/media/image16.01be3baf.JPG";